import { LiabilityType } from '/@/modules/liability/enums/LiabilityType';
import { UnpaidTaxLiabilityMeta } from '/@/modules/liability/models/meta/UnpaidTaxLiabilityMeta';
import { LoanAndCreditPaymentLiabilityMeta } from '/@/modules/liability/models/meta/LoanAndCreditPaymentLiabilityMeta';
import { PersonalExpenseLiabilityMeta } from '/@/modules/liability/models/meta/PersonalExpenseLiabilityMeta';
import { OtherCreditorLiabilityMeta } from '/@/modules/liability/models/meta/OtherCreditorLiabilityMeta';
import { FuneralAndEstateExpenseLiabilityMeta } from '/@/modules/liability/models/meta/FuneralAndEstateExpenseLiabilityMeta';
import { CompensationLiabilityMeta } from '/@/modules/liability/models/meta/CompensationLiabilityMeta';
import { ExecutorDisbursementLiabilityMeta } from '/@/modules/liability/models/meta/ExecutorDisbursementLiabilityMeta';
import { EstimatedFinalTaxesLiabilityMeta } from '/@/modules/liability/models/meta/EstimatedFinalTaxesLiabilityMeta';
import { PotentialSpouseClaimLiabilityMeta } from '/@/modules/liability/models/meta/PotentialSpouseClaimLiabilityMeta';

export class LiabilityMeta {
  static factory(type, model = {}) {
    switch (type) {
      case LiabilityType.LOAN_AND_CREDIT_PAYMENT.key:
        return new LoanAndCreditPaymentLiabilityMeta(model);
      case LiabilityType.UNPAID_TAX.key:
        return new UnpaidTaxLiabilityMeta(model);
      case LiabilityType.PERSONAL_EXPENSE.key:
        return new PersonalExpenseLiabilityMeta(model);
      case LiabilityType.ESTATE_EXPENSE.key:
        return new FuneralAndEstateExpenseLiabilityMeta(model);
      case LiabilityType.OTHER_CREDITOR.key:
        return new OtherCreditorLiabilityMeta(model);
      case LiabilityType.EXECUTOR_DISBURSEMENT.key:
        return new ExecutorDisbursementLiabilityMeta();
      case LiabilityType.ATTORNEY_COMPENSATION.key:
      case LiabilityType.EXECUTOR_COMPENSATION.key:
        return new CompensationLiabilityMeta(model);
      case LiabilityType.ESTIMATED_FINAL_TAXES.key:
        return new EstimatedFinalTaxesLiabilityMeta(model);
      case LiabilityType.POTENTIAL_SPOUSE_CLAIM.key:
        return new PotentialSpouseClaimLiabilityMeta(model);
      default:
        return null;
    }
  }
}
